import {FETCH_GROOMERS_FOR_SKIRESORT, DELETE_GROOMER, MODIFY_GROOMER, ADD_GROOMER} from './actions';
import {CHANGE_SKIRESORT} from './../global/actions';
import {LOGOUT} from './../user/actions';

import restCollection from './../_utils/restReducer';

export default restCollection({
  defaultStateAugment: {},
  actions: {
    index: {
      start: FETCH_GROOMERS_FOR_SKIRESORT.do,
      success: FETCH_GROOMERS_FOR_SKIRESORT.success,
      failure: FETCH_GROOMERS_FOR_SKIRESORT.failure
    },
    delete: {
      start: DELETE_GROOMER.do,
      success: DELETE_GROOMER.success,
      failure: DELETE_GROOMER.failure
    },
    put: {
      start: MODIFY_GROOMER.do,
      success: MODIFY_GROOMER.success,
      failure: MODIFY_GROOMER.failure
    },
    post: {
      start: ADD_GROOMER.do,
      success: ADD_GROOMER.success,
      failure: ADD_GROOMER.failure
    },
    reset: [CHANGE_SKIRESORT, LOGOUT]
  },
  fallback: (state/*, action*/) => {
    return state;
  }
});



// WEBPACK FOOTER //
// ./src/redux/groomers/reducer.js